export const en = {
    login: 'Yandex login',
    firstName: 'First Name',
    lastName: 'Last Name',
};
